module.exports = __webpack_public_path__ + "img/圍棋.f1865f9c.jpg";